import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager'

/* 개발담당: 양유빈
 * 화면기능: 도매북마크
 * 필수속성: Whole_Code, HeartOn
 * 옵션속성: CheckCss, UnCheckCss, CallBack(부모페이지 함수 호출)
*/

export class BookMarkStore extends Component {
    static displayName = BookMarkStore.name;

    constructor(props) {
        super(props);
        this.state = {
            HeartOn: null
        };
        this.handle_Click = this.handle_Click.bind(this);
    }
    //초기화
    componentDidMount() {
    }
    async handle_Click(event, HeartOn) {
        try {
            
            if (this.props.Whole_Code === undefined) {
                return false;
            }
          
            let Data = await Big3Common.Post("api/Common/Common/RegisterBokmkStore",
                {
                    whole_code: this.props.Whole_Code
                },
                true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ HeartOn: HeartOn });
                if (this.props.CallBack !== undefined) {
                    setTimeout(() => {
                        this.props.CallBack();
                    }, 300);
                    
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("BookMarkStore: ", e)
        }
        event.preventDefault();
    }
    render() {
         
        let CheckCss = this.props.CheckCss === undefined ? "heart_checked" : this.props.CheckCss;
        let UnCheckCss = this.props.UnCheckCss === undefined ? "heart" : this.props.UnCheckCss;
        let HeartOn = this.state.HeartOn === null ? this.props.HeartOn : this.state.HeartOn;
        if (HeartOn) {
            return (
                 <div className={CheckCss} onClick={(e) => this.handle_Click(e, false)}></div>
            );
        }
        else {
            return (
                <div className={UnCheckCss} onClick={(e) => this.handle_Click(e,true)}></div>
            );
        }
        
    }
}
